import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface searchStore {
    //검색 초기화
    reFreshFilter: boolean;
    setRefreshFilter: (refresh: boolean) => void;
}

export const useMapSearchStore = create<searchStore>()(
    devtools(set => ({
        reFreshFilter: false,
        setRefreshFilter: refresh => set({ reFreshFilter: refresh }),
    })),
);
